module.exports = __webpack_public_path__ + "static/img/dibu.5a1f3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/dibu.png
// module id = Hh4v
// module chunks = 1